import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ShareTokenBaloon" })
export default class ShareTokenBaloon extends Vue {
    public localizer: any = Localizer;

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get shareTokensDocumentIdMasters() {
        return this.$store.getters["myFileSharingStore/shareTokensDocumentIdMasters"];
    }
    
    get isShareTokenFormVisible() {
        return this.$store.getters["myFileSharingStore/isShareTokenFormVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.$store.dispatch("myFileSharingStore/getShareTokensDocumentIdMasters");
    }

    public showForm(value: boolean) {
        this.$store.commit("myFileSharingStore/setShareTokenFormVisible", value);
    }
}